const SubscriptionStatus = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  CANCEL_AT_PERIOD_END: "cancelAtPeriodEnd",
  CANCELED: "canceled",
};

export default SubscriptionStatus;
